export default __webpack_public_path__ + "static/media/misc-books2-2048w.c65431ab.png";